'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _typography = require('./styles/typography');

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlashMessage = function FlashMessage(_ref) {
    var messageText = _ref.messageText,
        borderColor = _ref.borderColor,
        backgroundColor = _ref.backgroundColor,
        padding = _ref.padding,
        style = _ref.style;
    var left = padding.left,
        right = padding.right,
        top = padding.top,
        bottom = padding.bottom;

    var flashMessageStyle = _extends({}, _typography.semibold, _typography.text, {
        backgroundColor: backgroundColor,
        border: '2px solid ' + borderColor,
        borderRadius: 3,
        paddingBottom: bottom,
        paddingLeft: left,
        paddingRight: right,
        paddingTop: top
    }, style);

    return _react2.default.createElement(
        'div',
        { style: flashMessageStyle },
        messageText
    );
};

FlashMessage.propTypes = {
    messageText: _react.PropTypes.string.isRequired,
    borderColor: _react.PropTypes.string,
    backgroundColor: _react.PropTypes.string,
    padding: _react.PropTypes.shape({
        left: _react.PropTypes.number,
        right: _react.PropTypes.number,
        top: _react.PropTypes.number,
        bottom: _react.PropTypes.number
    }),
    position: _react.PropTypes.string,
    style: _react.PropTypes.object
};

FlashMessage.defaultProps = {
    messageText: '',
    backgroundColor: '#F4EEFF',
    borderColor: '#DDCBFE',
    padding: {
        left: 30,
        right: 30,
        top: 7,
        bottom: 8
    },
    style: {}
};

exports.default = FlashMessage;
//# sourceMappingURL=FlashMessage.js.map